import { Component, Input, OnInit } from '@angular/core';
import { JsonPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { NgbDatepickerModule, NgbDateStruct, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedFormService } from '../../services/shared-form.service';
import { ApiService } from '../../services/api.service';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, filter, first, map } from 'rxjs';
import { Comune, Dizionario, Stato } from '../../model/model';
import { AssignComuniService } from '../../services/assign-comuni.service';
import { AssignStatiService } from '../../services/assign-stati.service';
import { SwitchModalitaService } from '../../services/switch-modalita.service';

@Component({
  selector: 'app-parte-b',
  standalone: true,
  imports: [NgIf, ReactiveFormsModule, FormsModule, NgbDatepickerModule, JsonPipe, NgClass, NgFor, NgbTypeaheadModule],
  templateUrl: './parte-b.component.html',
  styleUrl: './parte-b.component.scss'
})
export class ParteBComponent implements OnInit{
  selectedOptionLocalita: string = '';
  selectedOptionStatoCivile: string = '';
  selectedOptionResidenza: string = '';
  selectedOptionPosizioneProfessione: string = '';
  selectedOptionCittadinanza: string = '';
  parteBForm = this.sharedFormService.form.get('parteB') as FormGroup;
  dizionari!: Observable<Dizionario[] | any>;
  dizionarioLocalitaNascita: any;
  dizionarioStatoCivile: any;
  dizionarioLocalitaResidenza: any;
  dizionarioGradoIstruzione: any;
  dizionarioCondizioneProfessionale: any;
  dizionarioPosizioneProfessione: any;
  dizionarioRamoAttivita: any;
  dizionarioCittadinanza: any;
  @Input() schedaMorte!: any;
  dataAttuale!: Date;
  comuni!: Observable<Comune[] | any>;
  codComuni: any = [];
  descrComune: any = [];
  descProvince: any = [];
  descrAsl: any;
  stati!: Observable<Stato[] | any>;
  descrStato: any = [];

  //subscription
  condizione1Subscription: any;
  condizione2Subscription: any;
  condizione3Subscription: any;
  condizione4Subscription: any;
  condizione5Subscription: any;
  comuniSubscription: any;
  statiSubscription: any;

  cittadinanzaEsteraSubscription: any;

  disableSelect: boolean = false;

  invalidBorder(form: string) {
    if ((this.parteBForm.get(form)?.invalid && this.parteBForm.get(form)?.touched) || (this.parteBForm.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  onHourInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const firstDigit = parseInt(event.target.value[0], 10);
    const isBackspace = event.key === 'Backspace';
    const zero = event.key === '0';
    const uno = event.key === '1';
    const due = event.key === '2';
    const tre = event.key === '3';
    const isTab = event.key === 'Tab';

    if (firstDigit > 2 && !isBackspace && !isTab) {
      event.preventDefault();
    }
    else if(firstDigit == 2 && !zero && !uno && !due && !tre && !isBackspace && !isTab){
      event.preventDefault();
    }
    else if(input.value.length === maxLength && !isBackspace && !isTab){
      event.preventDefault();
    }
  }

  onMinuteInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const firstDigit = parseInt(event.target.value[0], 10);
    const isBackspace = event.key === 'Backspace';
    const isTab = event.key === 'Tab';

    if (firstDigit > 5 && !isBackspace && !isTab) {
      event.preventDefault();
    }
    else if(input.value.length === maxLength && !isBackspace && !isTab){
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.apiService.getDizionari().subscribe(dizionari => {
      this.dizionari = dizionari;
      this.dizionarioLocalitaNascita = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'LOCALITA_NASCITA');
      this.dizionarioStatoCivile = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'STATO_CIVILE');
      this.dizionarioLocalitaResidenza = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'RESIDENZA');
      this.dizionarioGradoIstruzione = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'GRADO_ISTRUZIONE');
      this.dizionarioCondizioneProfessionale = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'CONDIZIONE_PROFESSIONALE');
      this.dizionarioPosizioneProfessione = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'POSIZIONE_PROFESSIONE');
      this.dizionarioRamoAttivita = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'RAMO_ATTIVITA_ECONOMICA');
      this.dizionarioCittadinanza = dizionari.filter((dizionario: Dizionario) => dizionario.chiave == 'CITTADINANZA');
    })
    this.dataAttuale = new Date();
    this.comuniSubscription = this.apiService.getComuni().subscribe(comuni => {
      this.comuni = comuni;
      this.assignComuni.comuni = comuni;
      this.assignComuni.comuni.forEach((comune: Comune) => {
        comune.descrComune = comune.descrComune?.trim();
      })
      this.descrComune = comuni.map((comune: Comune) => comune.descrComune);
    })
    this.statiSubscription = this.apiService.getStati().subscribe(stati => {
      this.stati = stati;
      // this.assignStati.stati = stati;
      this.assignStati.stati.forEach((stato: Stato) => {
        stato.descrizione = stato.descrizione?.trim();
      })
      this.descrStato = stati.map((stato: Stato) => stato.descrizione);
    })

    this.condizione1Subscription = this.parteBForm.get('fkLocalitaStatoEsteroNascitaDescr')?.valueChanges.subscribe(() => {
      if (this.parteBForm.get('fkLocalitaStatoEsteroNascitaDescr')?.value != undefined) {
        const selectedStato = this.assignStati.stati.find((stato: Stato) => stato.descrizione?.trim() === this.parteBForm.get('fkLocalitaStatoEsteroNascitaDescr')?.value.trim());
        this.parteBForm.get('fkLocalitaStatoEsteroNascita')?.setValue(selectedStato?.codIstat);
      }
    })

    this.cittadinanzaEsteraSubscription = this.parteBForm.get('fkCittadinanzaStatoStranieraDesc')?.valueChanges.subscribe(() => {
      if(this.parteBForm.get('fkCittadinanzaStatoStranieraDesc')?.value != undefined) {
        const selectedStato = this.assignStati.stati.find((stato: Stato) => stato.descrizione?.trim() === this.parteBForm.get('fkCittadinanzaStatoStranieraDesc')?.value.trim());
        this.parteBForm.get('fkCittadinanzaStatoStraniera')?.setValue(selectedStato?.codIstat);
      }
    })

    this.condizione2Subscription = this.parteBForm.get('fkStatoResidenzaDescr')?.valueChanges.subscribe(() => {
      if (this.parteBForm.get('fkStatoResidenzaDescr')?.value != undefined) {
        const selectedStato = this.assignStati.stati.find((stato: Stato) => stato.descrizione?.trim() === this.parteBForm.get('fkStatoResidenzaDescr')?.value.trim());
        this.parteBForm.get('fkStatoResidenza')?.setValue(selectedStato?.codIstat);
      }
    })    

    this.condizione3Subscription = this.parteBForm.get('denominazione')?.get('fkComuneDescr')?.valueChanges.subscribe(() => {
      if (this.parteBForm.get('denominazione')?.get('fkComuneDescr')?.value != undefined) {
        const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.parteBForm.get('denominazione')?.get('fkComuneDescr')?.value.trim());
        this.parteBForm.get('denominazione')?.get('fkComune')?.setValue(selectedComune?.codComune);
        this.parteBForm.get('denominazione')?.get('provincia')?.setValue(selectedComune?.sigla);
      }
    })
    this.condizione4Subscription = this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.valueChanges.subscribe(() => {
      if (this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.value != undefined) {
        const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.value.trim());
        this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascita')?.setValue(selectedComune?.codComune);
        this.parteBForm.get('altroComuneNascita')?.get('provincia')?.setValue(selectedComune?.sigla);
      }
    })
    this.condizione5Subscription = this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.valueChanges.subscribe(() => {
      if (this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.value != undefined) {
        const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.descrComune?.trim() === this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.value.trim());
        this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenza')?.setValue(selectedComune?.codComune);
        this.parteBForm.get('altroComuneResidenza')?.get('provincia')?.setValue(selectedComune?.sigla);
      }
    })
  }

  ngAfterViewInit() {
    if(!this.schedaMorte.modalita && !this.schedaMorte.giaInModifica){
      console.log(this.schedaMorte.modalita)
      console.log(this.schedaMorte.giaInModifica)
      this.parteBForm.disable();
      this.disableSelect = true;
    }
    else{
      this.parteBForm.enable();
      this.disableSelect = false;
    }
    this.schedaMorte.modificaSubject.pipe(first()).subscribe((modifica: boolean) => {
      if(modifica){
        this.parteBForm.enable();
        this.disableSelect = false;
      }
    });
    if(this.parteBForm.get('fkCittadinanzaStatoStraniera')?.value != ''){
      const selectedStato = this.assignStati.stati.find((stato: Stato) => stato.codIstat === this.parteBForm.get('fkCittadinanzaStatoStraniera')?.value);
      this.parteBForm.get('fkCittadinanzaStatoStranieraDesc')?.setValue(selectedStato?.descrizione);
    }
    if (this.parteBForm.get('fkLocalitaStatoEsteroNascita')?.value != '') {
      const selectedStato = this.assignStati.stati.find((stato: Stato) => stato.codIstat === this.parteBForm.get('fkLocalitaStatoEsteroNascita')?.value);
      this.parteBForm.get('fkLocalitaStatoEsteroNascitaDescr')?.setValue(selectedStato?.descrizione);
    }
    if (this.parteBForm.get('fkStatoResidenza')?.value != '') {
      const selectedStato = this.assignStati.stati.find((stato: Stato) => stato.codIstat === this.parteBForm.get('fkStatoResidenza')?.value);
      this.parteBForm.get('fkStatoResidenzaDescr')?.setValue(selectedStato?.descrizione);
    }
    if (this.parteBForm.get('denominazione')?.get('fkComune')?.value != '') {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.codComune === this.parteBForm.get('denominazione')?.get('fkComune')?.value);
      this.parteBForm.get('denominazione')?.get('fkComuneDescr')?.setValue(selectedComune?.descrComune);
    }
    if (this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascita')?.value != '') {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.codComune === this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascita')?.value);
      this.parteBForm.get('altroComuneNascita')?.get('fkLocalitaComuneNascitaDescr')?.setValue(selectedComune?.descrComune);
    }
    if (this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenza')?.value != '') {
      const selectedComune = this.assignComuni.comuni.find((comune: Comune) => comune.codComune === this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenza')?.value);
      this.parteBForm.get('altroComuneResidenza')?.get('fkComuneResidenzaDescr')?.setValue(selectedComune?.descrComune);
    }
  }

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.descrComune.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  search2: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2 ? [] : this.descrStato.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  invalidBorderGroup(form: string, group: string) {
    if ((this.parteBForm.get(group)?.get(form)?.invalid && this.parteBForm.get(group)?.get(form)?.touched) || (this.parteBForm.get(group)?.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderComune(form: string, group: string, codComune: string) {
    if ((this.parteBForm.get(group)?.get(form)?.invalid && this.parteBForm.get(group)?.get(form)?.touched) ||
      (this.parteBForm.get(group)?.get(form)?.invalid && this.schedaMorte.attivaBordi)
      || (this.parteBForm.get(group)?.get(codComune)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  invalidBorderSubGroup(form: string, group: string, subgroup: string) {
    if ((this.parteBForm.get(group)?.get(subgroup)?.get(form)?.invalid && this.parteBForm.get(group)?.get(subgroup)?.get(form)?.touched) || (this.parteBForm.get(group)?.get(subgroup)?.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }

  showInputResidenza(value: Event) {
    this.selectedOptionResidenza = (value.target as HTMLSelectElement).value;
    this.setSelectedOption(this.selectedOptionResidenza, '3', 'fkStatoResidenzaDescr');
    this.setSelectedOption(this.selectedOptionResidenza, '3', 'fkStatoResidenza');
    this.setSelectedOptionGroup(this.selectedOptionResidenza, 'fkComuneResidenza', '2', 'altroComuneResidenza');
    this.setSelectedOptionGroup(this.selectedOptionResidenza, 'fkComuneResidenzaDescr', '2', 'altroComuneResidenza');
    this.setSelectedOptionGroup(this.selectedOptionResidenza, 'provincia', '2', 'altroComuneResidenza');
  }

  showInputStatoCivile(value: Event) {
    this.selectedOptionStatoCivile = (value.target as HTMLSelectElement).value;
    if (this.selectedOptionStatoCivile == '2' || this.selectedOptionStatoCivile == '5' || this.selectedOptionStatoCivile == '6') {
      this.parteBForm.get('casiStatoCivile')?.get('anniNascitaconiuge')?.addValidators(Validators.required);
      this.parteBForm.get('casiStatoCivile')?.get('annoMatrimonioUnione')?.addValidators(Validators.required);
    } else {
      this.parteBForm.get('casiStatoCivile')?.get('anniNascitaconiuge')?.clearValidators();
      this.parteBForm.get('casiStatoCivile')?.get('annoMatrimonioUnione')?.clearValidators();
      this.parteBForm.get('casiStatoCivile')?.get('anniNascitaconiuge')?.reset();
      this.parteBForm.get('casiStatoCivile')?.get('annoMatrimonioUnione')?.reset();
    }
    this.parteBForm.get('casiStatoCivile')?.get('anniNascitaconiuge')?.updateValueAndValidity();
    this.parteBForm.get('casiStatoCivile')?.get('annoMatrimonioUnione')?.updateValueAndValidity();
  }

  showInputLocalita(value: Event) {
    this.selectedOptionLocalita = (value.target as HTMLSelectElement).value;
    this.setSelectedOption(this.selectedOptionLocalita, '3', 'fkLocalitaStatoEsteroNascita');
    this.setSelectedOption(this.selectedOptionLocalita, '3', 'fkLocalitaStatoEsteroNascitaDescr');
    this.setSelectedOptionGroup(this.selectedOptionLocalita, 'fkLocalitaComuneNascita', '2', 'altroComuneNascita');
    this.setSelectedOptionGroup(this.selectedOptionLocalita, 'fkLocalitaComuneNascitaDescr', '2', 'altroComuneNascita');
    this.setSelectedOptionGroup(this.selectedOptionLocalita, 'provincia', '2', 'altroComuneNascita');
  }

  showInputCittadinanza(value: Event){
    this.selectedOptionCittadinanza = (value.target as HTMLSelectElement).value;
    this.setSelectedOption(this.selectedOptionCittadinanza, '3', 'fkCittadinanzaStatoStraniera');
    this.setSelectedOption(this.selectedOptionCittadinanza, '3', 'fkCittadinanzaStatoStranieraDesc');
  }

  maxLengthInput(event: any, maxLength: number) {
    const input = event.target as HTMLInputElement;
    const isBackspace = event.key === 'Backspace';
    const isTab = event.key === 'Tab';

    if (input.value.length === maxLength && !isBackspace && !isTab) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  limitInput(input: EventTarget | null, maxLength: number) {
    const inputElement = input as HTMLInputElement;
    if (inputElement && inputElement.value.length > maxLength) {
      inputElement.value = inputElement.value.slice(0, maxLength);
    }
  }

  onDateSelect(data: NgbDateStruct, group: string, form: string) {
    if (data) {
      const dataSelezionata = new Date(data.year, data.month - 1, data.day);
      this.parteBForm.get(group)?.get(form)?.setValue(dataSelezionata);
    }
  }

  onDateNascita(data: NgbDateStruct) {
    if (data) {
      const dataSelezionata = new Date(data.year, data.month - 1, data.day);
      this.parteBForm.get('dataNascita')?.setValue(dataSelezionata);
    }
  }


  constructor(private formBuilder: FormBuilder, private sharedFormService: SharedFormService, private apiService: ApiService,
    private assignComuni: AssignComuniService, private assignStati: AssignStatiService, private switchModalita: SwitchModalitaService) { }

  setSelectedOption(variable: any, value: any, form: string) {
    if (variable === value) {
      this.parteBForm.get(form)?.addValidators(Validators.required);
    }
    else {
      this.parteBForm.get(form)?.clearValidators();
      this.parteBForm.get(form)?.reset();
    }
    this.parteBForm.get(form)?.updateValueAndValidity();
  }

  setSelectedOptionGroup(variable: any, group: any, value: any, form: string) {
    if (variable === value) {
      this.parteBForm.get(form)?.get(group)?.addValidators(Validators.required);
    }
    else {
      this.parteBForm.get(form)?.get(group)?.clearValidators();
      this.parteBForm.get(form)?.get(group)?.reset();
    }
    this.parteBForm.get(form)?.get(group)?.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    if(this.cittadinanzaEsteraSubscription) {
      this.cittadinanzaEsteraSubscription.unsubscribe();
    }
    if(this.condizione1Subscription) {
      this.condizione1Subscription.unsubscribe();
    }
    if(this.condizione2Subscription) {
      this.condizione2Subscription.unsubscribe();
    }
    if(this.condizione3Subscription) {
      this.condizione3Subscription.unsubscribe();
    }
    if(this.condizione4Subscription) {
      this.condizione4Subscription.unsubscribe();
    }
    if(this.condizione5Subscription) {
      this.condizione5Subscription.unsubscribe();
    }
    if(this.comuniSubscription) {
      this.comuniSubscription.unsubscribe();
    }
    if(this.statiSubscription) {
      this.statiSubscription.unsubscribe();
    }
  }
}
